if (!customElements.get("product-preorder-countdown")) {
  class ProductPreorderCountdown extends HTMLElement {
    connectedCallback() {
      const timestamp = Number(this.dataset.timestamp);

      if (!Number.isFinite(timestamp)) {
        this.hideSection();
        return;
      }

      this.targetTime = timestamp * 1000;
      this.daysElement = this.querySelector(".countdown_block_days");
      this.hoursElement = this.querySelector(".countdown_block_hours");
      this.minutesElement = this.querySelector(".countdown_block_minutes");
      this.secondsElement = this.querySelector(".countdown_block_seconds");

      this.update();
      this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      const distance = this.targetTime - Date.now();

      if (distance <= 0) {
        window.clearInterval(this.interval);
        this.hideSection();
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      this.daysElement.textContent = String(days).padStart(2, "0");
      this.hoursElement.textContent = String(hours).padStart(2, "0");
      this.minutesElement.textContent = String(minutes).padStart(2, "0");
      this.secondsElement.textContent = String(seconds).padStart(2, "0");
    }

    hideSection() {
      const section = this.closest(".countdown-section");
      if (section) section.style.display = "none";
      else this.hidden = true;
    }
  }

  customElements.define("product-preorder-countdown", ProductPreorderCountdown);
}
